export default "__VITE_ASSET__CSK3Shsw__"